/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnhideMcpServerRequestBody,
  UnhideMcpServerRequestBody$Outbound,
  UnhideMcpServerRequestBody$outboundSchema,
} from "../components/unhidemcpserverrequestbody.js";

export type UnhideMcpServerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UnhideMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  unhideMcpServerRequestBody: UnhideMcpServerRequestBody;
};

/** @internal */
export type UnhideMcpServerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UnhideMcpServerSecurity$outboundSchema: z.ZodMiniType<
  UnhideMcpServerSecurity$Outbound,
  UnhideMcpServerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function unhideMcpServerSecurityToJSON(
  unhideMcpServerSecurity: UnhideMcpServerSecurity,
): string {
  return JSON.stringify(
    UnhideMcpServerSecurity$outboundSchema.parse(unhideMcpServerSecurity),
  );
}

/** @internal */
export type UnhideMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UnhideMcpServerRequestBody: UnhideMcpServerRequestBody$Outbound;
};

/** @internal */
export const UnhideMcpServerRequest$outboundSchema: z.ZodMiniType<
  UnhideMcpServerRequest$Outbound,
  UnhideMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    unhideMcpServerRequestBody: UnhideMcpServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      unhideMcpServerRequestBody: "UnhideMcpServerRequestBody",
    });
  }),
);

export function unhideMcpServerRequestToJSON(
  unhideMcpServerRequest: UnhideMcpServerRequest,
): string {
  return JSON.stringify(
    UnhideMcpServerRequest$outboundSchema.parse(unhideMcpServerRequest),
  );
}
